import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { Link } from "react-router-dom";
import axios from "axios";
import Navbar from "../common-component/navbar/Navbar";
import LeftSection from "../common-component/left-menu-section/LeftSection";
import { BACKEND_URL, fastApiCall, fastApiClient } from "../common/Common";
import "../vendor-details/VendorDetails.css";
import "./SearchPage.css";

// Import images
import nopost from "../../assets/vendordetails/nopost.png";
import nodata from "../../assets/experience/nodata.png";
import businessicon from "../../assets/home-images/businessicon.jpg";
import { FeedMediaContent, useMediaHeight, MediaType } from "../home/FeedMediaContent .js";
import threedot from '../../assets/home-images/mid-section-images/threedot.png';
import videomute from "../../assets/home-images/mid-section-images/videomute.png";
import videounmute from "../../assets/home-images/mid-section-images/videounmute.png";
import hearticon from '../../assets/home-images/mid-section-images/hearticon.png';
import commenticon from '../../assets/home-images/mid-section-images/commenticon.png';
import shareicon from '../../assets/home-images/mid-section-images/shareicon.png';
import save from '../../assets/home-images/save.png';
import search from '../../assets/home-images/search.png';
import leftarrow from '../../assets/offers/leftarrow.png';
import Slider from "react-slick";
import Hls from "hls.js";
import popup_yatch from "../../assets/offers/popup_yatch.png";

import hayatlogo from '../../assets/home-images/right-section-images/hayatlogo.png';
import qr from '../../assets/home-images/right-section-images/qr.png';
import app_store from '../../assets/home-images/right-section-images/app_store.png';
import play_store from '../../assets/home-images/right-section-images/play_store.png';
import xmark from '../../assets/home-images/right-section-images/xmark.png';

// Helper function to detect if text is Arabic
const isArabic = (text) => {
    if (!text) return false;
    const arabicPattern = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/;
    return arabicPattern.test(text);
};

// Translation cache to store already translated text
const translationCache = new Map();

// Frontend translation function using Google Translate free API
const translateText = async (text, targetLang = 'en') => {
    try {
        const cacheKey = `${text}_${targetLang}`;
        if (translationCache.has(cacheKey)) {
            return translationCache.get(cacheKey);
        }

        const sourceLang = isArabic(text) ? 'ar' : 'auto';
        const translateUrl = `https://translate.googleapis.com/translate_a/single?client=gtx&sl=${sourceLang}&tl=${targetLang}&dt=t&q=${encodeURIComponent(text)}`;

        const proxyServices = [
            `https://api.allorigins.win/raw?url=${encodeURIComponent(translateUrl)}`,
            `https://api.allorigins.win/get?url=${encodeURIComponent(translateUrl)}`,
            `https://corsproxy.io/?${encodeURIComponent(translateUrl)}`,
        ];

        const parseTranslation = (data) => {
            let translated = '';
            let responseData = data;

            if (data.contents) {
                try {
                    responseData = JSON.parse(data.contents);
                } catch (e) {
                    responseData = data;
                }
            }

            if (Array.isArray(responseData) && Array.isArray(responseData[0])) {
                translated = responseData[0]
                    .map(segment => segment && Array.isArray(segment) && segment[0] ? segment[0] : '')
                    .join('')
                    .trim();
            }
            return translated;
        };

        const proxyPromises = proxyServices.map((proxyUrl, index) => {
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 5000);

            return fetch(proxyUrl, {
                method: 'GET',
                signal: controller.signal,
                headers: { 'Accept': 'application/json' }
            })
                .then(response => {
                    clearTimeout(timeoutId);
                    if (response.ok) {
                        return response.json().then(data => ({ data, index }));
                    }
                    throw new Error(`Proxy ${index + 1} returned ${response.status}`);
                })
                .catch(error => {
                    clearTimeout(timeoutId);
                    if (error.name !== 'AbortError') {
                        console.warn(`Proxy ${index + 1} failed:`, error.message);
                    }
                    throw error;
                });
        });

        try {
            const results = await Promise.allSettled(proxyPromises);
            for (const result of results) {
                if (result.status === 'fulfilled') {
                    const { data, index } = result.value;
                    const translated = parseTranslation(data);
                    if (translated && translated !== text && translated.length > 0) {
                        translationCache.set(cacheKey, translated);
                        return translated;
                    }
                }
            }
        } catch (raceError) {
            console.warn("All parallel requests failed, trying sequential fallback");
        }

        for (let i = 0; i < proxyServices.length; i++) {
            try {
                const controller = new AbortController();
                const timeoutId = setTimeout(() => controller.abort(), 5000);
                const response = await fetch(proxyServices[i], {
                    method: 'GET',
                    signal: controller.signal,
                    headers: { 'Accept': 'application/json' }
                });
                clearTimeout(timeoutId);
                if (response.ok) {
                    const responseData = await response.json();
                    const translated = parseTranslation(responseData);
                    if (translated && translated !== text && translated.length > 0) {
                        translationCache.set(cacheKey, translated);
                        return translated;
                    }
                }
            } catch (proxyError) {
                if (proxyError.name !== 'AbortError') {
                    console.warn(`Proxy ${i + 1} failed:`, proxyError.message);
                }
                continue;
            }
        }

        throw new Error("Translation failed - all proxy services unavailable.");
    } catch (error) {
        console.error("Translation error:", error);
        throw error;
    }
};

// Helper function to get search position score (lower score = higher priority)
const getSearchPositionScore = (text, searchTerm) => {
    if (!text || !searchTerm) return Infinity;
    const textLower = text.toLowerCase();
    const searchLower = searchTerm.toLowerCase().trim();
    const position = textLower.indexOf(searchLower);

    if (position === -1) return Infinity; // Not found

    // Lower position = higher priority
    // Position 0 (starts with) = highest priority
    return position;
};

// Helper function to calculate discount text
const getDiscountText = (item, className = "offer-tag") => {
    switch (item.discount_type_id) {
        case 8:
        case 4:
            return <span className={className}>{item.discount_type}</span>;
        case 7:
            return (
                <span className={className}>
                    {item.discount_value ? `${item.discount_value}% OFF` : item.discount_type}
                </span>
            );
        case 5:
            return (
                <span className={className}>
                    Up to {item.discount_value ? `${item.discount_value}% OFF` : ""}
                </span>
            );
        case 1:
            return item.discount_value && item.discount_price && item.coupon_price ? (
                <>
                    <span className="old-price">AED {item.coupon_price}</span>
                    <span className="new-price">AED {item.discount_price}</span>
                    <span className="separator">|</span>
                    <span className={className}>{item.discount_value}% OFF</span>
                </>
            ) : (
                <span className={className}>AED {item.coupon_price}</span>
            );
        case 10:
            return className === "limited-deals-tag" ? (
                <span className={className}>From AED {item.coupon_price}</span>
            ) : (
                <span className="discount_type_from">
                    From <span className="discount_coupon_price">AED {item.coupon_price}</span>
                </span>
            );
        default:
            return item.discount_type === "Total" ? (
                <span className={className}>{item.discount_value}% OFF</span>
            ) : (
                <span className={className}>{item.discount_type}</span>
            );
    }
};

// Coupon Card Component
const CouponCard = ({ coupon, isOverlay = false, categoryId = '' }) => {
    if (!coupon) return null;

    return (
        <Link
            to={`/offers/${coupon.coupon_id}/${coupon.category_id || categoryId || 0}`}
            className={`review-post-coupon-card ${isOverlay ? 'review-post-coupon-overlay' : 'review-post-coupon-inline'}`}
        >
            <div className="review-post-coupon-content">
                <div className="review-post-coupon-image">
                    <img
                        src={coupon.coupon_image}
                        alt={coupon.coupon_title || "Coupon"}
                        loading="lazy"
                        onError={(e) => {
                            e.target.src = "/no-image.png";
                        }}
                    />
                </div>
                <div className="review-post-coupon-info">
                    <h4 className="review-post-coupon-title">{coupon.coupon_title}</h4>
                    <p className="review-post-coupon-location">{coupon.location}</p>
                    <div className="review-post-coupon-discount">
                        {getDiscountText(coupon, "review-post-coupon-discount-tag")}
                    </div>
                </div>
            </div>
        </Link>
    );
};

// Hook to detect mobile and tablet
const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 992);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return isMobile;
};

// Review Image Slider Component
const ReviewImageSlider = ({ post, activeSlide, sliderSettings, coupons = [], categoryId = '' }) => {
    const isMobile = useIsMobile();

    const hasMultipleImages = post.post_images && post.post_images.length > 1;
    const hasSingleImage = post.post_images &&
        post.post_images.length === 1 &&
        post.post_images[0].post_images;

    let mediaType, mediaHeight, mediaWidth;

    if (hasMultipleImages) {
        mediaType = MediaType.MULTI_POST;
        const firstImage = post.post_images[0];
        mediaHeight = firstImage.height;
        mediaWidth = firstImage.width;
    } else if (hasSingleImage) {
        mediaType = MediaType.IMAGE;
        const image = post.post_images[0];
        mediaHeight = image.height;
        mediaWidth = image.width;
    }

    const calculatedHeight = useMediaHeight(mediaHeight, mediaWidth, mediaType);
    const isTallMedia = mediaHeight && mediaHeight > 1024;
    const isViewType12 = post.view_type === 12;
    const objectFit = isMobile
        ? 'cover'
        : (isTallMedia || isViewType12 ? 'contain' : 'cover');
    const backgroundColor = isMobile ? 'transparent' : ((isTallMedia || isViewType12) ? '#000' : 'transparent');

    if (hasMultipleImages) {
        return (
            <div
                className="multi-post-image"
                style={{
                    height: calculatedHeight ? `${calculatedHeight}px` : 'auto',
                    backgroundColor: backgroundColor,
                    position: 'relative',
                    width: '100%'
                }}
            >
                <div className="image-counter">
                    {activeSlide + 1} / {post.post_images.length}
                </div>
                <Slider {...sliderSettings} style={{ height: '100%' }}>
                    {post.post_images.map((img, idx) => {
                        const imgIsTall = img.height && img.height > 1024;
                        const imgObjectFit = isMobile ? 'cover' : ((imgIsTall || isViewType12) ? 'contain' : 'cover');
                        const imgBackgroundColor = isMobile ? 'transparent' : ((imgIsTall || isViewType12) ? '#000' : 'transparent');
                        return (
                            <div
                                className="slide-wrapper"
                                key={idx}
                                style={{
                                    height: calculatedHeight ? `${calculatedHeight}px` : 'auto',
                                    width: '100%',
                                    backgroundColor: imgBackgroundColor
                                }}
                            >
                                <img
                                    src={img.post_images}
                                    alt={`Post ${post.id} Image ${idx + 1}`}
                                    className="review-image-content"
                                    style={{
                                        width: '100%',
                                        height: calculatedHeight ? `${calculatedHeight}px` : 'auto',
                                        objectFit: imgObjectFit,
                                        display: 'block',
                                        backgroundColor: imgBackgroundColor
                                    }}
                                />
                            </div>
                        );
                    })}
                </Slider>
                {coupons && coupons.length > 0 && (
                    <div className="review-post-coupon-overlay-container review-post-coupon-fixed-overlay">
                        {coupons.map((coupon, couponIdx) => (
                            <CouponCard key={couponIdx} coupon={coupon} isOverlay={true} categoryId={categoryId} />
                        ))}
                    </div>
                )}
            </div>
        );
    } else if (hasSingleImage) {
        return (
            <div
                style={{
                    height: calculatedHeight ? `${calculatedHeight}px` : 'auto',
                    backgroundColor: backgroundColor,
                    position: 'relative',
                    width: '100%',
                    overflow: 'hidden'
                }}
            >
                <img
                    src={post.post_images[0].post_images}
                    alt={`Post ${post.id} Image`}
                    className="review-image-content"
                    style={{
                        width: '100%',
                        height: calculatedHeight ? `${calculatedHeight}px` : 'auto',
                        objectFit: objectFit,
                        display: 'block'
                    }}
                />
                {coupons && coupons.length > 0 && (
                    <div className="review-post-coupon-overlay-container">
                        {coupons.map((coupon, couponIdx) => (
                            <CouponCard key={couponIdx} coupon={coupon} isOverlay={true} categoryId={categoryId} />
                        ))}
                    </div>
                )}
            </div>
        );
    }

    return null;
};

const SearchPage = () => {
    const { vendorId } = useParams();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const searchQuery = searchParams.get("search");
    const [activeTab, setActiveTab] = useState("Posts");
    const [vendorpostlist, setVendorpostlist] = useState([]);
    const [vendorcouponlist, setVendorcouponlist] = useState([]);
    const [searchPostList, setSearchPostList] = useState([]);
    const [searchOfferList, setSearchOfferList] = useState([]);
    const [searchEventList, setSearchEventList] = useState([]);
    const [vendoreventlist, setVendoreventlist] = useState([]);
    const [activeSlide, setActiveSlide] = useState(0);
    const [globalMute, setGlobalMute] = useState(true);
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);
    const [expand, setExpand] = useState({});
    const [downloadPopupOpen, setDownloadPopupOpen] = useState(false);
    const [isSearchMode, setIsSearchMode] = useState(false);

    // Search states
    const [searchText, setSearchText] = useState("");
    const [vendorList, setVendorList] = useState([]);
    const [allVendors, setAllVendors] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const [isSearchLoading, setIsSearchLoading] = useState(false);
    const searchDebounceTimerRef = useRef(null);
    const searchBoxRef = useRef(null);
    const dropdownRef = useRef(null);
    const [selectedVendorName, setSelectedVendorName] = useState("");
    // Initialize loading states to true if we're in search mode with a query (will be set to false after first load)
    const [isPostsLoading, setIsPostsLoading] = useState(() => {
        const params = new URLSearchParams(window.location.search);
        const hasSearchQuery = params.get("search");
        return !!hasSearchQuery;
    });
    const [isOffersLoading, setIsOffersLoading] = useState(() => {
        const params = new URLSearchParams(window.location.search);
        const hasSearchQuery = params.get("search");
        return !!hasSearchQuery;
    });
    const [isEventsLoading, setIsEventsLoading] = useState(() => {
        const params = new URLSearchParams(window.location.search);
        const hasSearchQuery = params.get("search");
        return !!hasSearchQuery;
    });
    const [isVideosLoading, setIsVideosLoading] = useState(() => {
        const params = new URLSearchParams(window.location.search);
        const hasSearchQuery = params.get("search");
        return !!hasSearchQuery;
    });
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // More Less for Description
    const [reviewExpand, setReviewExpand] = useState({});
    const [translatedTexts, setTranslatedTexts] = useState({}); // Store translated text for each post
    const [isTranslated, setIsTranslated] = useState({}); // Track if post is currently showing translation
    const [isTranslating, setIsTranslating] = useState({}); // Track if translation is in progress

    // Video initialization function (similar to VendorDetails.js)
    const initializeVideo = (el, videoUrl, videoIndex) => {
        if (!el || !videoUrl || el.dataset.hlsInitialized) return;

        // Dynamically construct the proxy URL based on environment
        const backendBase = BACKEND_URL.replace('/api/', ''); // Get base URL without /api/

        // Extract just the filename from the video URL
        const filename = videoUrl.split('/').pop();

        // Construct the proxy URL dynamically
        const proxyUrl = `${backendBase}/video/${filename}`;

        console.log('Loading video from:', proxyUrl);

        const playMutedVideo = () => {
            el.muted = true;
            el.volume = 0;
            el.play().catch(err => console.log('Autoplay prevented:', err));
        };

        if (Hls.isSupported()) {
            const hls = new Hls({
                debug: false,
                enableWorker: true,
                lowLatencyMode: false,
                backBufferLength: 90,
                maxBufferLength: 30,
                maxMaxBufferLength: 60,
                maxBufferSize: 60 * 1000 * 1000,
                startLevel: 0,
                autoStartLoad: true,
                progressive: true,
                xhrSetup: function (xhr) {
                    xhr.withCredentials = false;
                    xhr.timeout = 10000;
                }
            });

            hls.loadSource(proxyUrl);
            hls.attachMedia(el);

            hls.on(Hls.Events.MANIFEST_PARSED, () => {
                playMutedVideo();
            });

            hls.on(Hls.Events.ERROR, (event, data) => {
                console.error('HLS Error:', data);
                if (data.fatal) {
                    switch (data.type) {
                        case Hls.ErrorTypes.NETWORK_ERROR:
                            hls.startLoad();
                            break;
                        case Hls.ErrorTypes.MEDIA_ERROR:
                            hls.recoverMediaError();
                            break;
                        default:
                            hls.destroy();
                            break;
                    }
                }
            });

            el.dataset.hlsInitialized = 'true';
            el.hlsInstance = hls;
        } else if (el.canPlayType('application/vnd.apple.mpegurl')) {
            el.src = proxyUrl;
            playMutedVideo();
            el.dataset.hlsInitialized = 'true';
        } else {
            // Fallback for regular video files
            el.src = videoUrl;
            playMutedVideo();
        }

        el.dataset.videoIndex = videoIndex;
    };

    const toggleMute = () => {
        const newMuteState = !globalMute;
        setGlobalMute(newMuteState);

        // Apply to all videos
        document.querySelectorAll('video[data-video-index]').forEach(videoElement => {
            videoElement.muted = newMuteState;
            videoElement.volume = newMuteState ? 0 : 1;

            // Play video to allow sound (some browsers require this)
            if (!newMuteState) {
                videoElement.play().catch(err => console.log('Play failed after unmute:', err));
            }
        });
    };

    // Helper function to check if a post contains videos (same logic as VendorDetails.js)
    const hasVideo = (post) => {
        if (!post) return false;

        // Primary check: video_file (same as VendorDetails.js)
        if (post.video_file && post.video_file !== "") {
            return true;
        }

        // Check media_files array for video files
        if (post.media_files && Array.isArray(post.media_files)) {
            return post.media_files.some(media => {
                if (typeof media === 'string') {
                    // If it's a string URL, check extension
                    return /\.(mp4|webm|ogg|mov|m3u8|ts)$/i.test(media);
                } else if (media && typeof media === 'object') {
                    // If it's an object, check for video properties
                    return media.media_type === 'video' ||
                        media.type === 'video' ||
                        (media.media_files && /\.(mp4|webm|ogg|mov|m3u8|ts)$/i.test(media.media_files));
                }
                return false;
            });
        }

        // Check for video property directly
        if (post.video || post.video_url) {
            return true;
        }

        // Check post_video property
        if (post.post_video && post.post_video.trim() !== '') {
            return true;
        }

        return false;
    };

    // Filter data based on active tab
    const getFilteredData = () => {
        if (activeTab === "Posts") {
            // If in search mode, return search results, otherwise vendor posts
            // Show all posts including videos
            return isSearchMode ? searchPostList : vendorpostlist;
        } else if (activeTab === "Videos") {
            // If in search mode, return search results, otherwise vendor posts
            const allPosts = isSearchMode ? searchPostList : vendorpostlist;
            // Filter only videos for Videos tab
            return allPosts.filter(post => hasVideo(post));
        }
        return [];
    };

    const filteredData = getFilteredData();

    // Get offers based on mode
    const getOffersData = () => {
        return isSearchMode ? searchOfferList : (vendorcouponlist.coupons || []);
    };

    const offersData = getOffersData();

    // Get events based on mode
    const getEventsData = () => {
        return isSearchMode ? searchEventList : (vendoreventlist || []);
    };

    const eventsData = getEventsData();

    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        beforeChange: (current, next) => setActiveSlide(next),
    };

    // ACTION TYPE COLOR FOR THE ACTION TYPE
    const getActionTypeColor = (actionTypeId) => {
        switch (actionTypeId) {
            case 1: return "#1877F1";
            case 2: return "#7949FF";
            case 3: return "#0C00E8";
            case 4: return "#116C15";
            case 5: return "#04A676";
            case 6: return "#CA09FF";
            case 7: return "#FE0761";
            case 8: return "#FF17E8";
            case 9: return "#E80500";
            case 10: return "#FF7700";
            case 11: return "#03A5C9";
            case 12: return "#0A4A19";
            default: return "#1877F1";
        }
    };

    // Shimmer Component for Posts
    const ShimmerPosts = () => (
        <div className="search-page-posts-list">
            {[1, 2, 3].map((item) => (
                <div key={item} className="feed-card shimmer-post-card">
                    <div className="feed-header shimmer-post-header">
                        <div className="profile-info shimmer-profile-info">
                            <div className="shimmer-circle shimmer-avatar"></div>
                            <div className="hotelname shimmer-hotel-name">
                                <div className="shimmer-line shimmer-hotel-title"></div>
                                <div className="shimmer-line shimmer-hotel-subtitle"></div>
                            </div>
                        </div>
                        <div className="header-actions shimmer-header-actions">
                            <div className="shimmer-box shimmer-btn-follow"></div>
                        </div>
                    </div>
                    <div className="shimmer-box shimmer-post-image"></div>
                    <div className="post-content-text shimmer-post-content">
                        <div className="shimmer-line shimmer-text-medium"></div>
                        <div className="shimmer-line shimmer-text-small"></div>
                        <div className="shimmer-line shimmer-text-small"></div>
                    </div>
                </div>
            ))}
        </div>
    );

    // Shimmer Component for Offers
    const ShimmerOffers = () => (
        <div className="search-page-offers-list">
            {[1, 2, 3, 4].map((item) => (
                <div key={item} className="shimmer-offer-card">
                    <div className="offer-image shimmer-box shimmer-offer-image"></div>
                    <div className="offer-details shimmer-offer-details">
                        <div className="shimmer-line shimmer-offer-location"></div>
                        <div className="shimmer-line shimmer-offer-title"></div>
                        <div className="shimmer-line shimmer-offer-distance"></div>
                        <div className="shimmer-line shimmer-offer-price"></div>
                    </div>
                </div>
            ))}
        </div>
    );

    // Shimmer Component for Events
    const ShimmerEvents = () => (
        <div className="search-page-offers-list">
            {[1, 2, 3, 4].map((item) => (
                <div key={item} className="shimmer-offer-card">
                    <div className="offer-image shimmer-box shimmer-offer-image"></div>
                    <div className="offer-details shimmer-offer-details">
                        <div className="shimmer-line shimmer-offer-location"></div>
                        <div className="shimmer-line shimmer-offer-title"></div>
                        <div className="shimmer-line shimmer-offer-distance"></div>
                        <div className="shimmer-line shimmer-offer-price"></div>
                    </div>
                </div>
            ))}
        </div>
    );

    // Shimmer Component for Videos (reuse Posts shimmer)
    const ShimmerVideos = () => (
        <div className="search-page-posts-list">
            {[1, 2, 3].map((item) => (
                <div key={item} className="feed-card shimmer-post-card">
                    <div className="feed-header shimmer-post-header">
                        <div className="profile-info shimmer-profile-info">
                            <div className="shimmer-circle shimmer-avatar"></div>
                            <div className="hotelname shimmer-hotel-name">
                                <div className="shimmer-line shimmer-hotel-title"></div>
                                <div className="shimmer-line shimmer-hotel-subtitle"></div>
                            </div>
                        </div>
                        <div className="header-actions shimmer-header-actions">
                            <div className="shimmer-box shimmer-btn-follow"></div>
                        </div>
                    </div>
                    <div className="shimmer-box shimmer-post-image"></div>
                    <div className="post-content-text shimmer-post-content">
                        <div className="shimmer-line shimmer-text-medium"></div>
                        <div className="shimmer-line shimmer-text-small"></div>
                    </div>
                </div>
            ))}
        </div>
    );

    // Fetch vendor details to get vendor name
    const fetchVendorDetails = async () => {
        try {
            if (!vendorId) return;

            // First, check if vendor exists in the current vendor list
            const existingVendor = allVendors.find(v =>
                (v.user_id || v.vendor_id || v.id)?.toString() === vendorId.toString()
            );

            if (existingVendor) {
                const vendorName = existingVendor.vendor_name || existingVendor.user_name || existingVendor.name || "";
                setSelectedVendorName(vendorName);
                setSearchText(vendorName);
                return vendorName;
            }

            // If not found in list, fetch from API
            await fastApiCall(
                () => fastApiClient.post(`${BACKEND_URL}website/get-vendor-details`, {
                    id: vendorId
                }),
                null,
                (vendorData) => {
                    const vendorName = vendorData.vendor_name || vendorData.user_name || vendorData.name || "";
                    setSelectedVendorName(vendorName);
                    setSearchText(vendorName);
                }
            );
        } catch (error) {
            console.log("Error fetching Vendor details", error);
            setSelectedVendorName("");
        }
    };

    // Fetch vendor posts
    const fetchVendorPostList = async () => {
        if (!vendorId) return;

        try {
            console.log("Fetching vendor posts for ID:", vendorId);
            await fastApiCall(
                () => fastApiClient.post(`${BACKEND_URL}website/get-vendor-post-list`, {
                    login_user_id: 501,
                    user_id: vendorId,
                }),
                (loading) => {
                    setIsPostsLoading(loading);
                    setIsVideosLoading(loading);
                },
                (data) => {
                    setVendorpostlist(data || []);
                }
            );
        } catch (error) {
            console.log("Error fetching Vendor post list", error);
            setVendorpostlist([]);
        }
    };

    // Fetch vendor offers
    const fetchVendorCouponList = async (lat, lng) => {
        if (!vendorId) return;

        const payload = {
            latitude: lat,
            longitude: lng,
            user_id: vendorId,
        };

        try {
            await fastApiCall(
                () => fastApiClient.post(`${BACKEND_URL}website/get-vendor-coupon-list`, payload),
                setIsOffersLoading,
                (data) => {
                    setVendorcouponlist(data || { coupons: [] });
                }
            );
        } catch (error) {
            console.log("Error fetching Vendor Coupon list", error);
            setVendorcouponlist({ coupons: [] });
        }
    };

    // Fetch vendor events
    const fetchVendorEventList = async () => {
        if (!vendorId) {
            console.log("Vendor user_id not available");
            return;
        }
        if (latitude === null || longitude === null) {
            console.log("Waiting for coordinates...");
            return;
        }

        const payload = {
            user_id: vendorId,
            login_user_id: 501,
            latitude: latitude || 24.4539,
            longitude: longitude || 54.3773,
        };

        try {
            console.log("Fetching vendor events for ID:", vendorId);
            await fastApiCall(
                () => fastApiClient.post(`${BACKEND_URL}website/get-vendor-event-list`, payload),
                setIsEventsLoading,
                (data) => {
                    setVendoreventlist(data || []);
                    console.log("Vendor events response:", data);
                }
            );
        } catch (error) {
            console.log("Error fetching Vendor Event list", error);
            setVendoreventlist([]);
        }
    };

    // Fetch search post list
    const fetchSearchPostList = async (searchValue) => {
        if (!searchValue || searchValue.trim().length === 0) return;

        const payload = {
            login_user_id: 501,
            latitude: latitude || 24.517725,
            longitude: longitude || 54.363599,
            search: searchValue.trim(),
        };

        try {
            await fastApiCall(
                () => fastApiClient.post(`${BACKEND_URL}website/search-post-list`, payload),
                (loading) => {
                    setIsPostsLoading(loading);
                    setIsVideosLoading(loading);
                },
                (data) => {
                    // Handle different response structures - only extract posts
                    let posts = [];

                    if (Array.isArray(data)) {
                        // If it's an array, check if items have post-like properties
                        data.forEach(item => {
                            if (item.post_id || item.id || item.description || item.media_files) {
                                posts.push(item);
                            }
                        });
                    } else {
                        // Handle object response
                        if (data.posts) {
                            posts = Array.isArray(data.posts) ? data.posts : [];
                        } else if (data.normal_post) {
                            posts = Array.isArray(data.normal_post) ? data.normal_post : [];
                        } else if (data.data && Array.isArray(data.data)) {
                            // Check if data array contains posts
                            data.data.forEach(item => {
                                if (item.post_id || item.id || item.description || item.media_files) {
                                    posts.push(item);
                                }
                            });
                        }
                    }

                    setSearchPostList(posts);
                    console.log("Search posts results:", posts.length);
                }
            );
        } catch (error) {
            console.error("Error fetching search post list:", error);
            setSearchPostList([]);
        }
    };

    // Fetch search offers/coupons list (similar to LeftSection.js)
    const fetchSearchOfferList = async (searchValue) => {
        if (!searchValue || searchValue.trim().length === 0) {
            setSearchOfferList([]);
            return;
        }

        console.log("[SearchPage] fetchSearchOfferList called with:", {
            searchValue,
            latitude,
            longitude,
            hasLatitude: latitude !== null,
            hasLongitude: longitude !== null
        });

        setIsOffersLoading(true);

        try {
            // First, try with search term - API might return matching offers
            const payloadWithSearch = {
                login_user_id: 501,
                latitude: latitude || 24.517725,
                longitude: longitude || 54.363599,
                search: searchValue.trim(),
            };

            let coupons = [];

            // Try with search term first
            try {
                await fastApiCall(
                    () => fastApiClient.post(`${BACKEND_URL}website/search-post-list`, payloadWithSearch),
                    null,
                    (data) => {
                        // Extract coupon_list from response
                        if (Array.isArray(data)) {
                            // If it's an array, filter for coupons
                            coupons = data.filter(item => item.coupon_id || item.coupon_title || item.discount_type_id);
                        } else {
                            // Handle object response - check all possible fields
                            if (data.coupon_list) {
                                coupons = Array.isArray(data.coupon_list) ? data.coupon_list : [];
                            } else if (data.offers) {
                                coupons = Array.isArray(data.offers) ? data.offers : [];
                            } else if (data.coupons) {
                                coupons = Array.isArray(data.coupons) ? data.coupons : [];
                            } else if (data.data && Array.isArray(data.data)) {
                                // Check data.data array for coupons
                                coupons = data.data.filter(item => item.coupon_id || item.coupon_title || item.discount_type_id);
                            }
                        }
                        console.log("[SearchPage] Offers from API with search term:", coupons.length, "coupons");
                    }
                );
            } catch (error) {
                console.log("Error with search term, trying empty search:", error);
            }

            // If no coupons found with search term, try with empty search to get all coupons
            if (coupons.length === 0) {
                const payloadEmpty = {
                    login_user_id: 501,
                    latitude: latitude || 24.517725,
                    longitude: longitude || 54.363599,
                    search: "", // Empty search to get all coupons - we'll filter client-side
                };

                try {
                    await fastApiCall(
                        () => fastApiClient.post(`${BACKEND_URL}website/search-post-list`, payloadEmpty),
                        null,
                        (data) => {
                            // Extract coupon_list from response
                            if (Array.isArray(data)) {
                                coupons = data.filter(item => item.coupon_id || item.coupon_title || item.discount_type_id);
                            } else {
                                if (data.coupon_list) {
                                    coupons = Array.isArray(data.coupon_list) ? data.coupon_list : [];
                                } else if (data.offers) {
                                    coupons = Array.isArray(data.offers) ? data.offers : [];
                                } else if (data.coupons) {
                                    coupons = Array.isArray(data.coupons) ? data.coupons : [];
                                } else if (data.data && Array.isArray(data.data)) {
                                    coupons = data.data.filter(item => item.coupon_id || item.coupon_title || item.discount_type_id);
                                }
                            }
                            console.log("[SearchPage] All coupons from API (empty search):", coupons.length, "coupons");
                        }
                    );
                } catch (error) {
                    console.log("Error fetching all coupons:", error);
                }
            }

            // CLIENT-SIDE FILTERING: Filter coupons based on BOTH coupon_title AND user_name
            // This allows searching by coupon_title (which backend doesn't support)
            const searchLower = searchValue.toLowerCase().trim();
            const filteredCoupons = coupons.filter((coupon) => {
                const couponTitle = String(coupon.coupon_title || "").toLowerCase().trim();
                const userName = String(coupon.user_name || "").toLowerCase().trim();

                // Check if search term appears in coupon_title OR user_name
                const titleMatch = couponTitle.includes(searchLower);
                const nameMatch = userName.includes(searchLower);

                return titleMatch || nameMatch;
            });

            console.log("[SearchPage] Filtered coupons after client-side filtering:", {
                searchValue,
                totalCoupons: coupons.length,
                filteredCount: filteredCoupons.length,
                sampleCoupons: filteredCoupons.slice(0, 3).map(c => ({
                    coupon_title: c.coupon_title,
                    user_name: c.user_name
                }))
            });

            // Sort coupons by search term position in coupon_title (earlier position = higher priority)
            // Prioritize coupon_title over user_name for sorting
            const sortedCoupons = filteredCoupons.sort((a, b) => {
                const aTitle = (a.coupon_title || "").toLowerCase();
                const bTitle = (b.coupon_title || "").toLowerCase();
                const aName = (a.user_name || "").toLowerCase();
                const bName = (b.user_name || "").toLowerCase();

                // Get position score for coupon_title (primary) and user_name (fallback)
                const aTitleScore = getSearchPositionScore(aTitle, searchLower);
                const bTitleScore = getSearchPositionScore(bTitle, searchLower);
                const aNameScore = getSearchPositionScore(aName, searchLower);
                const bNameScore = getSearchPositionScore(bName, searchLower);

                // Prioritize coupon_title: if both have title match, compare by title position
                // If one has title match and other doesn't, title match wins
                // If neither has title match, compare by user_name
                const aScore = aTitleScore !== Infinity ? aTitleScore : (aNameScore !== Infinity ? aNameScore + 1000 : Infinity);
                const bScore = bTitleScore !== Infinity ? bTitleScore : (bNameScore !== Infinity ? bNameScore + 1000 : Infinity);

                return aScore - bScore; // Lower score comes first
            });

            setSearchOfferList(sortedCoupons);
            console.log("[SearchPage] Final search offers results:", sortedCoupons.length, "offers");
        } catch (error) {
            console.error("Error fetching search offer list:", error);
            setSearchOfferList([]);
        } finally {
            setIsOffersLoading(false);
        }
    };

    // Fetch search events list (similar to LeftSection.js)
    const fetchSearchEventList = async (searchValue) => {
        if (!searchValue || searchValue.trim().length === 0) {
            setSearchEventList([]);
            return;
        }

        // Only proceed if we have coordinates
        if (latitude === null || longitude === null) {
            console.log("Waiting for coordinates...");
            return;
        }

        // IMPORTANT: Backend API may not search by title, so we call API to get ALL events, then filter client-side
        const payload = {
            login_user_id: 501,
            latitude: latitude || 24.4539,
            longitude: longitude || 54.3773,
            state_id: "",
            user_id: "",
        };

        try {
            await fastApiCall(
                () => fastApiClient.post(`${BACKEND_URL}website/get-event-list`, payload),
                setIsEventsLoading,
                (data) => {
                    const eventsArray = Array.isArray(data) ? data : [];

                    // CLIENT-SIDE FILTERING: Filter events based on title
                    const searchLower = searchValue.toLowerCase().trim();
                    const filteredEvents = eventsArray.filter((event) => {
                        const eventTitle = String(event.title || "").toLowerCase().trim();
                        return eventTitle.includes(searchLower);
                    });

                    // Sort events by search term position in title (earlier position = higher priority)
                    const sortedEvents = filteredEvents.sort((a, b) => {
                        const aTitle = (a.title || "").toLowerCase();
                        const bTitle = (b.title || "").toLowerCase();

                        const aScore = getSearchPositionScore(aTitle, searchLower);
                        const bScore = getSearchPositionScore(bTitle, searchLower);

                        return aScore - bScore; // Lower score comes first
                    });

                    setSearchEventList(sortedEvents);
                    console.log("Search events results:", sortedEvents.length);
                }
            );
        } catch (error) {
            console.error("Error fetching search event list:", error);
            setSearchEventList([]);
        }
    };

    // Combined search function that fetches all types
    // Fire all API calls independently - each updates UI as soon as it completes
    // This provides progressive loading for better perceived performance
    const fetchAllSearchResults = (searchValue) => {
        if (!searchValue || searchValue.trim().length === 0) return;

        // Fire all API calls independently - no await, no Promise.all
        // Each function manages its own loading state and updates UI when complete
        fetchSearchPostList(searchValue);
        fetchSearchOfferList(searchValue);
        fetchSearchEventList(searchValue);
    };

    // Get user location
    useEffect(() => {
        console.log("[SearchPage] Initializing geolocation...");
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    console.log("[SearchPage] Geolocation success:", {
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude
                    });
                    setLatitude(position.coords.latitude);
                    setLongitude(position.coords.longitude);
                },
                (error) => {
                    console.error("[SearchPage] Error getting location:", error);
                    console.log("[SearchPage] Using default coordinates (Abu Dhabi)");
                    setLatitude(24.4539);
                    setLongitude(54.3773);
                }
            );
        } else {
            console.log("[SearchPage] Geolocation not supported, using default coordinates");
            setLatitude(24.4539);
            setLongitude(54.3773);
        }
    }, []);

    // Check if we're in search mode (has search query but no vendorId)
    useEffect(() => {
        console.log("[SearchPage] Mode detection:", {
            vendorId,
            searchQuery,
            willSetSearchMode: !vendorId && !!searchQuery
        });

        if (vendorId) {
            // If vendorId exists, fetch vendor details and show vendor name
            setIsSearchMode(false);
            fetchVendorDetails();
        } else if (searchQuery) {
            // If there's a search query but no vendorId, set it in the search box
            console.log("[SearchPage] Entering search mode with query:", searchQuery);
            setSearchText(searchQuery);
            setIsSearchMode(true);
            // Set loading states to true when entering search mode
            setIsPostsLoading(true);
            setIsVideosLoading(true);
            setIsOffersLoading(true);
            setIsEventsLoading(true);
        } else {
            setIsSearchMode(false);
            setSearchText("");
            setSelectedVendorName("");
        }
    }, [searchQuery, vendorId]);

    // Fetch data when vendorId or location changes
    useEffect(() => {
        if (vendorId && !isSearchMode) {
            fetchVendorPostList();
        }
    }, [vendorId, isSearchMode]);

    useEffect(() => {
        if (vendorId && latitude && longitude && !isSearchMode) {
            fetchVendorCouponList(latitude, longitude);
        }
    }, [vendorId, latitude, longitude, isSearchMode]);

    // Fetch vendor events when Events tab is active
    useEffect(() => {
        if (activeTab === "Events" && vendorId && !isSearchMode && latitude !== null && longitude !== null) {
            fetchVendorEventList();
        }
    }, [activeTab, vendorId, isSearchMode, latitude, longitude]);

    // Mobile detection for description truncation
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // Fetch search results when search query or location changes
    useEffect(() => {
        console.log("[SearchPage] Search useEffect triggered:", {
            isSearchMode,
            searchQuery,
            latitude,
            longitude,
            hasLatitude: latitude !== null,
            hasLongitude: longitude !== null,
            willTriggerSearch: isSearchMode && searchQuery && latitude !== null && longitude !== null
        });

        if (isSearchMode && searchQuery && latitude !== null && longitude !== null) {
            console.log("[SearchPage] Triggering fetchAllSearchResults with query:", searchQuery);
            fetchAllSearchResults(searchQuery);
        } else if (isSearchMode && searchQuery && (latitude === null || longitude === null)) {
            console.warn("[SearchPage] Search mode active but coordinates not available yet. Waiting for coordinates...");
        }
    }, [isSearchMode, searchQuery, latitude, longitude]);

    // Update vendor name when vendor list loads and vendorId exists
    useEffect(() => {
        if (vendorId && allVendors.length > 0 && !selectedVendorName) {
            const existingVendor = allVendors.find(v =>
                (v.user_id || v.vendor_id || v.id)?.toString() === vendorId.toString()
            );
            if (existingVendor) {
                const vendorName = existingVendor.vendor_name || existingVendor.user_name || existingVendor.name || "";
                setSelectedVendorName(vendorName);
                setSearchText(vendorName);
            }
        }
    }, [allVendors, vendorId, selectedVendorName]);

    // Intersection Observer for auto play/pause based on scroll
    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    const video = entry.target;
                    if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
                        // Video is 50% or more visible
                        video.play().catch(err => console.log('Play prevented:', err));
                    } else {
                        // Video is out of view
                        video.pause();
                    }
                });
            },
            {
                threshold: [0, 0.5, 1], // Trigger at 0%, 50%, and 100% visibility
                rootMargin: '0px'
            }
        );

        // Observe all video elements
        const videos = document.querySelectorAll('video[data-video-index]');
        videos.forEach(video => observer.observe(video));

        return () => {
            videos.forEach(video => observer.unobserve(video));
            observer.disconnect();
        };
    }, [filteredData, globalMute]);

    // Search functions
    const fetchVendorList = async (searchValue = "") => {
        const payload = {
            login_user_id: 501,
            search_text: searchValue || ""
        }

        try {
            await fastApiCall(
                () => fastApiClient.post(`${BACKEND_URL}website/get-vendor-list`, payload),
                setIsSearchLoading,
                (data) => {
                    const vendorsArray = Array.isArray(data?.data || data) ? (data?.data || data) : [];

                    if (vendorsArray.length > allVendors.length || allVendors.length === 0) {
                        setAllVendors(vendorsArray);
                    }

                    const filteredVendors = filterVendorsBySearch(vendorsArray, searchValue);
                    setVendorList(filteredVendors);
                }
            );
        } catch (error) {
            console.error("Error fetching vendor data:", error);
            setVendorList([]);
        }
    }

    const filterVendorsBySearch = (vendors, searchValue) => {
        if (!searchValue || searchValue.trim() === "") {
            return vendors;
        }

        const searchLower = searchValue.toLowerCase().trim();
        return vendors.filter((vendor) => {
            const vendorName = (vendor.vendor_name || vendor.user_name || vendor.name || "").toLowerCase();
            const businessType = (vendor.type_of_business || vendor.business_type || "").toLowerCase();
            const city = (vendor.city || "").toLowerCase();

            return (
                vendorName.includes(searchLower) ||
                businessType.includes(searchLower) ||
                city.includes(searchLower)
            );
        });
    }

    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchText(value);

        if (value.trim().length > 0) {
            setShowDropdown(true);
        } else {
            setShowDropdown(false);
            if (allVendors.length > 0) {
                setVendorList(allVendors);
            }
        }

        if (allVendors.length > 0) {
            const filtered = filterVendorsBySearch(allVendors, value);
            setVendorList(filtered);
        }

        if (searchDebounceTimerRef.current) {
            clearTimeout(searchDebounceTimerRef.current);
        }

        searchDebounceTimerRef.current = setTimeout(() => {
            fetchVendorList(value);
        }, 300);
    };

    const handleSearch = () => {
        if (searchText.trim().length > 0) {
            // Close dropdown when search is performed
            setShowDropdown(false);
            // Navigate to search page with new search query
            navigate(`/searchpage?search=${encodeURIComponent(searchText.trim())}`);
        }
    };

    const handleSearchEnter = (e) => {
        if (e.key === "Enter" && searchText.trim().length > 0) {
            handleSearch();
        }
    };

    const handleVendorSelect = (vendor) => {
        const vendorName = vendor.vendor_name || vendor.user_name || vendor.name || "";
        setSearchText(vendorName);
        setSelectedVendorName(vendorName);
        setShowDropdown(false);
    };

    const handleClearSearch = () => {
        setSearchText("");
        setShowDropdown(false);
        if (allVendors.length > 0) {
            setVendorList(allVendors);
        } else {
            fetchVendorList("");
        }
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dropdownRef.current &&
                searchBoxRef.current &&
                !dropdownRef.current.contains(event.target) &&
                !searchBoxRef.current.contains(event.target)
            ) {
                setShowDropdown(false);
            }
        };

        if (showDropdown) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showDropdown]);

    // Initial fetch on component mount
    useEffect(() => {
        fetchVendorList();

        return () => {
            if (searchDebounceTimerRef.current) {
                clearTimeout(searchDebounceTimerRef.current);
            }
        };
    }, []);

    return (
        <div>
            <Navbar />

            <div className="search-page main-layout">
                <LeftSection initialSearchValue={selectedVendorName || searchQuery || ""} />
                <main className="search-page middle-section">
                    {/* Search Box - Above Tabs */}
                    <div className="search-page-search-container">
                        <div className="search-page-searchbox" ref={searchBoxRef}>
                            <img
                                src={leftarrow}
                                alt="back"
                                className="search-page-back-arrow"
                                onClick={() => navigate(-1)}
                            />
                            <img
                                src={search}
                                alt="search"
                                className="search-page-search-icon"
                                onClick={handleSearch}
                                style={{ cursor: "pointer" }}
                            />
                            <input
                                type="text"
                                placeholder="Search..."
                                value={searchText}
                                onChange={handleSearchChange}
                                onKeyDown={handleSearchEnter}
                                onFocus={() => {
                                    if (searchText.trim().length > 0 && (vendorList.length > 0 || isSearchMode)) {
                                        setShowDropdown(true);
                                    }
                                }}
                            />
                            {searchText && searchText.trim().length > 0 && (
                                <img
                                    src={xmark}
                                    alt="clear"
                                    className="search-page-search-clear-icon"
                                    onClick={handleClearSearch}
                                    style={{ cursor: "pointer", display: "block" }}
                                />
                            )}
                        </div>

                        {/* Vendor list dropdown */}
                        {showDropdown && searchText.trim().length > 0 && (
                            <div className="search-page-vendor-list-container" ref={dropdownRef}>
                                {isSearchLoading ? (
                                    <div className="search-page-vendor-list-loading">Loading...</div>
                                ) : vendorList.length > 0 ? (
                                    vendorList.map((vendor, index) => {
                                        const vendorId = vendor.user_id || vendor.vendor_id || vendor.id;
                                        const vendorName = vendor.vendor_name || vendor.user_name || vendor.name || "Unknown Vendor";
                                        const vendorImage = vendor.user_image || vendor.vendor_cover_image || vendor.profile_image || "";

                                        return (
                                            <Link
                                                key={vendorId || index}
                                                to={`/searchpage/${vendorId}`}
                                                className="search-page-vendor-list-item remove-underline"
                                                onClick={() => handleVendorSelect(vendor)}
                                            >
                                                {vendorImage && (
                                                    <img
                                                        src={vendorImage}
                                                        alt={vendorName}
                                                        className="search-page-vendor-list-image"
                                                    />
                                                )}
                                                <span className="search-page-vendor-list-name">{vendorName}</span>
                                            </Link>
                                        );
                                    })
                                ) : (
                                    null
                                )}
                            </div>
                        )}
                    </div>

                    <div className="search-page-tabs-section">
                        <div className="search-page-tabs">
                            <button
                                className={activeTab === "Posts" ? "search-page-tab-active" : ""}
                                onClick={() => setActiveTab("Posts")}
                            >
                                Posts
                            </button>
                            <button
                                className={activeTab === "Videos" ? "search-page-tab-active" : ""}
                                onClick={() => setActiveTab("Videos")}
                            >
                                Videos
                            </button>
                            <button
                                className={activeTab === "Offers" ? "search-page-tab-active" : ""}
                                onClick={() => setActiveTab("Offers")}
                            >
                                Offers
                            </button>
                            <button
                                className={activeTab === "Events" ? "search-page-tab-active" : ""}
                                onClick={() => setActiveTab("Events")}
                            >
                                Events
                            </button>
                        </div>

                        {/* Content Display */}
                        {activeTab === "Posts" && isPostsLoading ? (
                            <ShimmerPosts />
                        ) : activeTab === "Posts" && !isPostsLoading && filteredData.length === 0 ? (
                            <div className="search-page-nodata-message">
                                <img
                                    src={nopost}
                                    className="search-page-no-data-img"
                                    alt="no posts"
                                />
                                <p className="search-page-no-data-p1">No posts found</p>
                                <p className="search-page-no-data-p2">Come back later to explore</p>
                            </div>
                        ) : activeTab === "Offers" && isOffersLoading ? (
                            <ShimmerOffers />
                        ) : activeTab === "Offers" && !isOffersLoading && offersData.length === 0 ? (
                            <div className="search-page-nodata-message">
                                <img
                                    src={nodata}
                                    className="search-page-no-data-img"
                                    alt="no offers"
                                />
                                <p className="search-page-no-data-p1">No offers found</p>
                                <p className="search-page-no-data-p2">Come back later to explore</p>
                            </div>
                        ) : activeTab === "Videos" && isVideosLoading ? (
                            <ShimmerVideos />
                        ) : activeTab === "Videos" && !isVideosLoading && filteredData.length === 0 ? (
                            <div className="search-page-nodata-message">
                                <img
                                    src={nopost}
                                    className="search-page-no-data-img"
                                    alt="no videos"
                                />
                                <p className="search-page-no-data-p1">No videos found</p>
                                <p className="search-page-no-data-p2">Come back later to explore</p>
                            </div>
                        ) : activeTab === "Events" && isEventsLoading ? (
                            <ShimmerEvents />
                        ) : activeTab === "Events" && !isEventsLoading && eventsData.length === 0 ? (
                            <div className="search-page-nodata-message">
                                <img
                                    src={nodata}
                                    className="search-page-no-data-img"
                                    alt="no events"
                                />
                                <p className="search-page-no-data-p1">No events found</p>
                                <p className="search-page-no-data-p2">Come back later to explore</p>
                            </div>
                        ) : activeTab === "Videos" ? (
                            // Grid view for Videos tab (same as VendorDetails.js)
                            <div className="search-page-video-grid">
                                {filteredData.map((post, postIndex) => (
                                    <div
                                        key={post.id}
                                        className="search-page-video-grid-item"
                                        onClick={() => {
                                            navigate('/videoposts', {
                                                state: { postData: post, postIndex: postIndex }
                                            });
                                            sessionStorage.setItem('videopost_navigated', 'true');
                                            sessionStorage.setItem('fetch_all_videos', 'true');
                                        }}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <video
                                            ref={(el) => initializeVideo(el, post.video_file, `search-grid-${postIndex}`)}
                                            poster={post.video_cover_picture}
                                            muted
                                            loop
                                            preload="metadata"
                                            playsInline
                                            disablePictureInPicture
                                        />
                                    </div>
                                ))}
                            </div>
                        ) : activeTab === "Events" ? (
                            // Display Events
                            <div className="search-page-offers-list">
                                {eventsData.map((event) => {
                                    // Declare discountText inside map function body - same logic as offers
                                    let discountText;

                                    // Check if event has discount_type_id (same as offers)
                                    if (event.discount_type_id) {
                                        switch (event.discount_type_id) {
                                            case 8:
                                            case 4:
                                                discountText = <span className="offer-tag">{event.discount_type}</span>;
                                                break;
                                            case 7:
                                                discountText = <span className="offer-tag">{event.discount_value ? `${event.discount_value}% OFF` : event.discount_type}</span>;
                                                break;
                                            case 5:
                                                discountText = <span className="offer-tag">Up to {event.discount_value ? `${event.discount_value}% OFF` : ""}</span>;
                                                break;
                                            case 1:
                                                discountText = (event.discount_value && event.discount_price && event.coupon_price) ? (
                                                    <>
                                                        <span className="old-price">AED {event.coupon_price}</span>
                                                        <span className="new-price">AED {event.discount_price}</span>
                                                        <span className="separator">|</span>
                                                        <span className="discount">{event.discount_value}% OFF</span>
                                                    </>
                                                ) : (
                                                    <span className="offer-tag">AED {event.coupon_price}</span>
                                                );
                                                break;
                                            case 10:
                                                discountText = <span className="discount_type_from">From <span className="discount_coupon_price">AED {event.coupon_price}</span></span>;
                                                break;
                                            default:
                                                discountText = event.discount_type === "Total" ? (
                                                    <span className="offer-tag">{event.discount_value}% OFF</span>
                                                ) : (
                                                    <span className="offer-tag">{event.discount_type}</span>
                                                );
                                        }
                                    } else {
                                        // Fallback to simple price display if no discount_type_id
                                        if (Number(event.price_from) > 0) {
                                            discountText = event.price_to != null ? (
                                                <span className="discount_type_from">From <span className="discount_coupon_price">AED {event.price_from}</span></span>
                                            ) : (
                                                <span className="offer-tag">AED {event.price_from}</span>
                                            );
                                        }
                                    }

                                    return (
                                        <Link
                                            key={event.event_id || event.id}
                                            to={`/eventdetails/${event.event_id || event.id}`}
                                            className="remove-underline"
                                        >
                                            <div className="">
                                                <div className="offer-image">
                                                    {event.event_image && (
                                                        <img src={event.event_image} alt={event.title || event.event_title} />
                                                    )}
                                                </div>
                                                <div className="offer-details">
                                                    <p className="offer-location">
                                                        <span><img src={businessicon} alt="logo" className="bussinessicon" /></span>
                                                        <span>{event.user_name || (isSearchMode ? "" : selectedVendorName)}</span>
                                                    </p>
                                                    <h4>{event.title || event.event_title}</h4>
                                                    {event.location_name && (
                                                        <div className="kilometer-location">
                                                            <p className="offer-location">{event.location_name}</p>
                                                        </div>
                                                    )}
                                                    {/* Discount / Price - using same logic as offers */}
                                                    {discountText && (
                                                        <div className="offer-prices">{discountText}</div>
                                                    )}
                                                </div>
                                            </div>
                                        </Link>
                                    );
                                })}
                            </div>
                        ) : activeTab === "Offers" ? (
                            // Display Offers
                            <div className="search-page-offers-list">
                                {offersData.map((offer) => {
                                    let discountText;

                                    switch (offer.discount_type_id) {
                                        case 8:
                                        case 4:
                                            discountText = <span className="offer-tag">{offer.discount_type}</span>;
                                            break;
                                        case 7:
                                            discountText = <span className="offer-tag">{offer.discount_value ? `${offer.discount_value}% OFF` : offer.discount_type}</span>;
                                            break;
                                        case 5:
                                            discountText = <span className="offer-tag">Up to {offer.discount_value ? `${offer.discount_value}% OFF` : ""}</span>;
                                            break;
                                        case 1:
                                            discountText = (offer.discount_value && offer.discount_price && offer.coupon_price) ? (
                                                <>
                                                    <span className="old-price">AED {offer.coupon_price}</span>
                                                    <span className="new-price">AED {offer.discount_price}</span>
                                                    <span className="separator">|</span>
                                                    <span className="discount">{offer.discount_value}% OFF</span>
                                                </>
                                            ) : (
                                                <span className="offer-tag">AED {offer.coupon_price}</span>
                                            );
                                            break;
                                        case 10:
                                            discountText = <span className="discount_type_from">From <span className="discount_coupon_price">AED {offer.coupon_price}</span></span>;
                                            break;
                                        default:
                                            discountText = offer.discount_type === "Total" ? (
                                                <span className="offer-tag">{offer.discount_value}% OFF</span>
                                            ) : (
                                                <span className="offer-tag">{offer.discount_type}</span>
                                            );
                                    }

                                    return (
                                        <Link
                                            key={offer.coupon_id}
                                            to={`/offers/${offer.coupon_id}/0`}
                                            className="remove-underline"
                                        >
                                            <div className="">
                                                <div className="offer-image">
                                                    {offer.coupon_image && (
                                                        <img src={offer.coupon_image} alt={offer.coupon_title} />
                                                    )}
                                                </div>
                                                <div className="offer-details">
                                                    <p className="offer-location">
                                                        <span><img src={businessicon} alt="logo" className="bussinessicon" /></span>
                                                        <span>{offer.user_name}</span>
                                                    </p>
                                                    <h4>{offer.coupon_title}</h4>
                                                    <div className="kilometer-location">
                                                        <p className="offer-distance">{offer.distance?.toFixed(1)} km</p>
                                                        <span>|</span>
                                                        <p className="offer-location">{offer.location}</p>
                                                    </div>
                                                    <div className="offer-prices">{discountText}</div>
                                                </div>
                                            </div>
                                        </Link>
                                    );
                                })}
                            </div>
                        ) : (
                            // Full post view for Posts tab
                            <div className="search-page-posts-list">
                                {filteredData.map((post, postIndex) => {
                                    // Check if this is a review-style post (user_type === "0" and view_type === 11 or 12)
                                    const isReviewPost = String(post.user_type) === "0" && (post.view_type === 11 || post.view_type === 12);
                                    const isReviewWithImage = String(post.user_type) === "0" && post.view_type === 12;
                                    // Check if this is a background image post (user_type === "0" and view_type === 13)
                                    const isBackgroundImagePost = String(post.user_type) === "0" && post.view_type === 13;

                                    return (
                                        <div key={post.id} className={`feed-card ${isReviewPost ? 'review-card' : ''}`}>
                                            <div className="feed-header searchpage">
                                                <div className="profile-info">
                                                    <Link
                                                        to={String(post.user_type) === "0" ? `/userprofile/${post.user_id}` : `/vendordetails/${post.user_id}`}
                                                        className="remove-underline"
                                                    >
                                                        {post.user_image && post.user_image.trim() !== '' ? (
                                                            <img src={post.user_image} alt="feedcard1" />
                                                        ) : (
                                                            <div className="profile-initial">
                                                                {post.user_name ? post.user_name.charAt(0).toUpperCase() : '?'}
                                                            </div>
                                                        )}
                                                    </Link>

                                                    <div className="hotelname">
                                                        <div className="business-name-and-category-name">
                                                            {String(post.user_type) === "0" ? (
                                                                /* For user_type "0": username has no navigation, recommend_user has navigation */
                                                                <>
                                                                    <Link to={`/userprofile/${post.user_id}`} className="remove-underline">
                                                                        <h4>{post.user_name}</h4>
                                                                    </Link>
                                                                    {(post.view_type === 11 || post.view_type === 12) && (
                                                                        <>
                                                                            {/* For user_type "0", show only one: category_name OR recommend_user (not both) */}
                                                                            {post.category_name && post.category_name.trim() !== '' ? (
                                                                                <span className="looking-for">
                                                                                    looking for <strong>{post.category_name}</strong>
                                                                                </span>
                                                                            ) : post.recommend_user && post.recommend_user.user_name && post.recommend_user.user_name.trim() !== '' ? (
                                                                                <span className="recommend-text">
                                                                                    recommend
                                                                                    <Link
                                                                                        to={`/vendordetails/${post.recommend_user.user_id || post.recommend_user.id}`}
                                                                                        className="remove-underline"
                                                                                    >
                                                                                        <strong>{post.recommend_user.user_name}</strong>
                                                                                    </Link>
                                                                                </span>
                                                                            ) : null}
                                                                        </>
                                                                    )}
                                                                </>
                                                            ) : (
                                                                /* For other user_types: everything wrapped in Link */
                                                                <Link
                                                                    to={`/vendordetails/${post.user_id}`}
                                                                    className="remove-underline"
                                                                >
                                                                    <h4>{post.user_name}</h4>
                                                                    {(post.view_type === 11 || post.view_type === 12) && (
                                                                        <>
                                                                            {/* For other user_types, show both if they exist */}
                                                                            {post.category_name && post.category_name.trim() !== '' && (
                                                                                <span className="looking-for">
                                                                                    looking for <strong>{post.category_name}</strong>
                                                                                </span>
                                                                            )}
                                                                            {post.recommend_user && post.recommend_user.user_name && post.recommend_user.user_name.trim() !== '' && (
                                                                                <span className="recommend-text">
                                                                                    recommend <strong>{post.recommend_user.user_name}</strong>
                                                                                </span>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                </Link>
                                                            )}
                                                        </div>
                                                        <p>
                                                            {String(post.user_type) === "0" && post.post_location
                                                                ? post.post_location
                                                                : post.state
                                                            }
                                                        </p>
                                                        {/* | {post.following} Followers */}
                                                    </div>
                                                </div>

                                                <div className="header-actions">
                                                    {String(post.user_type) !== "0" && (
                                                        <p className="tag1" onClick={() => setDownloadPopupOpen(true)}>Follow</p>
                                                    )}
                                                    <div className="more-icon-container">
                                                        <img
                                                            src={threedot}
                                                            alt="threedot"
                                                            onClick={() => setDownloadPopupOpen(true)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Review-style content for user_type === "0" and view_type === 11 or 12 */}
                                            {isReviewPost ? (
                                                <div className="review-content">
                                                    {isReviewWithImage ? (
                                                        /* view_type === 12: Show description on top, then image */
                                                        <>
                                                            {post.description && post.description.trim() !== '' && (() => {
                                                                const descLimit = isMobile ? 60 : 100;
                                                                const descTruncateLength = isMobile ? 130 : 220;
                                                                const shouldTruncate = post.description.length > descTruncateLength;
                                                                const isExpanded = reviewExpand[post.id];

                                                                return (
                                                                    <div className="review-description">
                                                                        <p className="review-text">
                                                                            {isExpanded
                                                                                ? post.description
                                                                                : shouldTruncate
                                                                                    ? `${post.description.substring(0, descTruncateLength)}...`
                                                                                    : post.description
                                                                            }

                                                                            {shouldTruncate && (
                                                                                <span
                                                                                    className="review-text-toggle"
                                                                                    onClick={() =>
                                                                                        setReviewExpand(prev => ({
                                                                                            ...prev,
                                                                                            [post.id]: !prev[post.id]
                                                                                        }))
                                                                                    }
                                                                                >
                                                                                    {isExpanded ? "Less" : "More"}
                                                                                </span>
                                                                            )}
                                                                        </p>
                                                                    </div>
                                                                );
                                                            })()}

                                                            <div className="review-image">
                                                                {post.post_images && (post.post_images.length > 0 && post.post_images[0].post_images) ? (
                                                                    <ReviewImageSlider
                                                                        post={post}
                                                                        activeSlide={activeSlide}
                                                                        sliderSettings={sliderSettings}
                                                                        coupons={post.coupons || []}
                                                                        categoryId={post.category_id}
                                                                    />
                                                                ) : post.primary_image ? (
                                                                    <div style={{ position: 'relative', width: '100%' }}>
                                                                        <img
                                                                            src={post.primary_image}
                                                                            alt={`Post ${post.id}`}
                                                                            className="review-image-content"
                                                                            style={{ maxWidth: '100%', height: 'auto', objectFit: 'contain' }}
                                                                        />
                                                                        {post.coupons && post.coupons.length > 0 && (
                                                                            <div className="review-post-coupon-overlay-container">
                                                                                {post.coupons.map((coupon, couponIdx) => (
                                                                                    <CouponCard key={couponIdx} coupon={coupon} isOverlay={true} categoryId={post.category_id} />
                                                                                ))}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                ) : null}
                                                            </div>
                                                        </>
                                                    ) : (
                                                        /* view_type === 11: Show description */
                                                        <>
                                                            <div className={`review-description ${isArabic(post.description) ? 'arabic-text' : ''}`}>
                                                                {(post.description || translatedTexts[post.id]) && (() => {
                                                                    const textToShow =
                                                                        isTranslated[post.id] && translatedTexts[post.id]
                                                                            ? translatedTexts[post.id]
                                                                            : post.description;

                                                                    const descLimit = isMobile ? 50 : 100;
                                                                    const descTruncateLength = isMobile ? 120 : 210;
                                                                    const shouldTruncate = textToShow.length > descTruncateLength;
                                                                    const isExpanded = reviewExpand[post.id];

                                                                    return (
                                                                        <>
                                                                            <p
                                                                                className="review-text"
                                                                                dir={isArabic(post.description) && !isTranslated[post.id] ? "rtl" : "ltr"}
                                                                            >
                                                                                {isExpanded
                                                                                    ? textToShow
                                                                                    : shouldTruncate
                                                                                        ? `${textToShow.substring(0, descTruncateLength)}...`
                                                                                        : textToShow
                                                                                }

                                                                                {shouldTruncate && (
                                                                                    <span
                                                                                        className="review-text-toggle"
                                                                                        onClick={() =>
                                                                                            setReviewExpand(prev => ({
                                                                                                ...prev,
                                                                                                [post.id]: !prev[post.id]
                                                                                            }))
                                                                                        }
                                                                                    >
                                                                                        {isExpanded ? "Less" : "More"}
                                                                                    </span>
                                                                                )}
                                                                            </p>

                                                                            {/* Translation toggle */}
                                                                            {isArabic(post.description) && (
                                                                                <div className="review-translation-toggle">
                                                                                    {!isTranslated[post.id] && (
                                                                                        <>
                                                                                            {isTranslating[post.id] ? (
                                                                                                <span className="translation-loading">Translating...</span>
                                                                                            ) : (
                                                                                                <span
                                                                                                    className="translation-link"
                                                                                                    onClick={async () => {
                                                                                                        if (!translatedTexts[post.id]) {
                                                                                                            setIsTranslating(prev => ({ ...prev, [post.id]: true }));
                                                                                                            try {
                                                                                                                const translated = await translateText(post.description, 'en');
                                                                                                                if (translated && translated.trim()) {
                                                                                                                    setTranslatedTexts(prev => ({ ...prev, [post.id]: translated }));
                                                                                                                    setIsTranslated(prev => ({ ...prev, [post.id]: true }));
                                                                                                                } else {
                                                                                                                    alert("Translation failed.");
                                                                                                                }
                                                                                                            } catch (err) {
                                                                                                                console.error(err);
                                                                                                                alert("Translation failed.");
                                                                                                            } finally {
                                                                                                                setIsTranslating(prev => ({ ...prev, [post.id]: false }));
                                                                                                            }
                                                                                                        } else {
                                                                                                            setIsTranslated(prev => ({ ...prev, [post.id]: true }));
                                                                                                        }
                                                                                                    }}
                                                                                                >
                                                                                                    See Translation
                                                                                                </span>
                                                                                            )}
                                                                                        </>
                                                                                    )}

                                                                                    {isTranslated[post.id] && translatedTexts[post.id] && (
                                                                                        <span
                                                                                            className="translation-link translation-link-original"
                                                                                            onClick={() =>
                                                                                                setIsTranslated(prev => ({ ...prev, [post.id]: false }))
                                                                                            }
                                                                                        >
                                                                                            See Original
                                                                                        </span>
                                                                                    )}
                                                                                </div>
                                                                            )}
                                                                        </>
                                                                    );
                                                                })()}
                                                            </div>

                                                            {/* Coupons below description */}
                                                            {post.coupons && post.coupons.length > 0 && (
                                                                <div className="review-post-coupon-cards-container">
                                                                    {post.coupons.map((coupon, couponIdx) => (
                                                                        <CouponCard key={couponIdx} coupon={coupon} isOverlay={false} categoryId={post.category_id} />
                                                                    ))}
                                                                </div>
                                                            )}
                                                        </>
                                                    )}
                                                </div>
                                            ) : null}

                                            {/* Background image post for user_type === "0" and view_type === 13 */}
                                            {isBackgroundImagePost ? (
                                                <div
                                                    className="background-image-post"
                                                    style={{
                                                        backgroundImage: post.background_image ? `url(${post.background_image})` : 'none',
                                                        backgroundSize: 'cover',
                                                        backgroundPosition: 'center',
                                                        backgroundRepeat: 'no-repeat',
                                                        minHeight: '400px',
                                                        position: 'relative',
                                                        width: '100%',
                                                        aspectRatio: '1 / 1',
                                                        overflow: 'hidden'
                                                    }}
                                                >
                                                    {(post.description || post.background_image_title) && (
                                                        <div
                                                            className="background-image-content"
                                                            style={{
                                                                position: 'absolute',
                                                                top: '50%',
                                                                left: '50%',
                                                                transform: 'translate(-50%, -50%)',
                                                                color: post.background_image_title_color || 'black',
                                                                textAlign: 'center',
                                                                padding: '20px',
                                                                zIndex: 2,
                                                                width: '90%',
                                                                maxWidth: '100%'
                                                            }}
                                                        >
                                                            {post.background_image_title && (
                                                                <h3 style={{
                                                                    margin: '0 0 10px 0',
                                                                    color: post.background_image_title_color || 'black',
                                                                    fontSize: '24px',
                                                                    fontWeight: 'bold'
                                                                }}>
                                                                    {post.background_image_title}
                                                                </h3>
                                                            )}
                                                            {post.description && (
                                                                <p style={{
                                                                    margin: 0,
                                                                    color: post.background_image_title_color || 'black',
                                                                    fontSize: '18px',
                                                                    fontWeight: '500',
                                                                    wordWrap: 'break-word'
                                                                }}>
                                                                    {post.description}
                                                                </p>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            ) : null}

                                            {/* Only show media for non-review posts */}
                                            {!isReviewPost && !isBackgroundImagePost && (
                                                <FeedMediaContent
                                                    post={post}
                                                    index={postIndex}
                                                    activeSlide={activeSlide}
                                                    sliderSettings={sliderSettings}
                                                    initializeVideo={(el, videoUrl) => initializeVideo(el, videoUrl, postIndex)}
                                                    globalMute={globalMute}
                                                    toggleMute={toggleMute}
                                                    videomute={videomute}
                                                    videounmute={videounmute}
                                                    getActionTypeColor={getActionTypeColor}
                                                    showFullSlider={false}
                                                    isVendorDetails={true}
                                                />
                                            )}

                                            <div className="post-content-text">
                                                <div className="feed-actions">
                                                    <div className="left-icons">
                                                        <img src={hearticon} alt="heart icon" className="heart" onClick={() => setDownloadPopupOpen(true)} />
                                                        <span>{post.likes > 0 ? post.likes : ''}</span>
                                                        <p className="post-vertical-line">|</p>
                                                        <img src={commenticon} alt="comment icon" className="comment" onClick={() => setDownloadPopupOpen(true)} />
                                                        <span>{post.comments_count > 0 ? post.comments_count : ''}</span>
                                                        <p className="post-vertical-line">|</p>
                                                        <img src={shareicon} alt="share icon" className="shareicon" onClick={() => setDownloadPopupOpen(true)} />
                                                        <span></span>
                                                    </div>
                                                    <img src={save} alt="save" id="save" onClick={() => setDownloadPopupOpen(true)} />
                                                </div>

                                                {/* Show description for non-review posts, or timestamp for review posts */}
                                                {isReviewPost ? (
                                                    <div className="review-timestamp">
                                                        {/* Timestamp can be added here if needed */}
                                                    </div>
                                                ) : !isBackgroundImagePost ? (
                                                    <div className="feed-caption">
                                                        {post.description && (() => {
                                                            const descLimit = isMobile ? 60 : 100;
                                                            const descTruncateLength = isMobile ? 130 : 180;
                                                            const shouldTruncate = post.description.length > descTruncateLength;
                                                            const isExpanded = expand[post.id];

                                                            return (
                                                                <p className={`feed-caption-text ${isExpanded ? "expanded" : ""}`}>
                                                                    {isExpanded
                                                                        ? post.description
                                                                        : shouldTruncate
                                                                            ? `${post.description.substring(0, descTruncateLength)}... `
                                                                            : post.description
                                                                    }

                                                                    {shouldTruncate && (
                                                                        <span
                                                                            className="feed-caption-toggle"
                                                                            onClick={() => setExpand({ ...expand, [post.id]: !expand[post.id] })}
                                                                        >
                                                                            {isExpanded ? "Less" : "More"}
                                                                        </span>
                                                                    )}
                                                                </p>
                                                            );
                                                        })()}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                </main>
                <aside className="search-page right-section">
                    {/* Download App section */}
                    {/* <div className="download-app">
                        <div className="hayaticon">
                            <img src={hayatlogo} alt="Hayat In Logo" />
                            <a href="#close" className="close-btn">
                                <img src={xmark} alt="xmark" className="xmark" />
                            </a>
                        </div>
                        <h4>Download Hayat In App</h4>

                        <div className="store-buttons">
                            <div className="app_qr">
                                <a
                                    href="https://apps.apple.com/ae/app/hayat-in/id6738689937"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img src={app_store} alt="App Store" />
                                </a>

                                <a
                                    href="https://play.google.com/store/apps/details?id=com.hayatinapp.hayatin"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img src={play_store} alt="Google Play" />
                                </a>
                            </div>


                            <div className="app_qr">
                                <img className="qr" src={qr} alt="QR code" />
                            </div>
                        </div>
                    </div> */}

                    {/* Trending Section */}
                    {/* <div className="trending-section">
                                        <h3>Trending<span id="rightarrow"><img id="rightarrow-img" src={rightarrow} alt="rightarrow" /></span></h3>
                
                                        <div className="trend-card">
                                            <img src={hotel1} alt="hotel1" />
                                            <div className="trend-info">
                                                <h4>Dubai Desert Safari</h4>
                                                <p>1.8 km | Al Wahda Mall</p>
                                            </div>
                                            <div className="follow-rating">
                                                <button className="follow-btn">Follow</button>
                                                <span className="rating"><span id="rating-no" >5.0</span> ★</span>
                                            </div>
                
                                        </div>
                
                                        <div className="trend-card">
                                            <img src={hotel2} alt="hotel2" />
                                            <div className="trend-info">
                                                <h4>Balcon Bar Restaurant</h4>
                                                <p>1.8 km | Al Wahda Mall</p>
                                            </div>
                                            <div className="follow-rating">
                                                <button className="follow-btn">Follow</button>
                                                <span className="rating"><span id="rating-no" >5.0</span> ★</span>
                                            </div>
                                        </div>
                
                                        <div className="trend-card">
                                            <img src={hotel3} alt="hotel3" />
                                            <div className="trend-info">
                                                <h4>Nujum Desert Camp</h4>
                                                <p>1.8 km | Al Wahda Mall</p>
                                            </div>
                
                                            <div className="follow-rating">
                                                <button className="follow-btn">Follow</button>
                                                <span className="rating"><span id="rating-no" >5.0</span> ★</span>
                                            </div>
                                        </div>
                
                                        <div className="trend-card">
                                            <img src={hotel2} alt="hotel2" />
                                            <div className="trend-info">
                                                <h4>Balcon Bar Restaurant</h4>
                                                <p>1.8 km | Al Wahda Mall</p>
                                            </div>
                                            <div className="follow-rating">
                                                <button className="follow-btn">Follow</button>
                                                <span className="rating"><span id="rating-no" >5.0</span> ★</span>
                                            </div>
                                        </div>
                
                                        <div className="trend-card">
                                            <img src={hotel3} alt="hotel3" />
                                            <div className="trend-info">
                                                <h4>Nujum Desert Camp</h4>
                                                <p>1.8 km | Al Wahda Mall</p>
                                            </div>
                                            <div className="follow-rating">
                                                <button className="follow-btn">Follow</button>
                                                <span className="rating"><span id="rating-no" >5.0</span> ★</span>
                                            </div>
                                        </div>
                
                                        <div className="trend-card">
                                            <img src={hotel3} alt="hotel3" />
                                            <div className="trend-info">
                                                <h4>Nujum Desert Camp</h4>
                                                <p>1.8 km | Al Wahda Mall</p>
                                            </div>
                
                                            <div className="follow-rating">
                                                <button className="follow-btn">Follow</button>
                                                <span className="rating"><span id="rating-no" >5.0</span> ★</span>
                                            </div>
                                        </div>
                
                                        <div className="trend-card">
                                            <img src={hotel2} alt="hotel2" />
                                            <div className="trend-info">
                                                <h4>Balcon Bar Restaurant</h4>
                                                <p>1.8 km | Al Wahda Mall</p>
                                            </div>
                                            <div className="follow-rating">
                                                <button className="follow-btn">Follow</button>
                                                <span className="rating"><span id="rating-no" >5.0</span> ★</span>
                                            </div>
                                        </div>
                
                
                                    </div> */}

                    {/* Connections Section  */}
                    {/* <div className="connections-section">
                                        <div className="connections-header">
                                            <h3>Connections<span id="rightarrow"><img id="rightarrow-img" src={rightarrow} alt="rightarrow" /></span></h3>
                                        </div>
                
                                        <div className="connection-card">
                                            <img src={pic1} alt="pic1" />
                                            <p>Najm Al-Barq</p>
                                            <button className="connect-btn">Connect</button>
                                        </div>
                                        <div className="connection-card">
                                            <img src={pic2} alt="pic2" />
                                            <p>Lina</p>
                                            <button className="connect-btn">Connect</button>
                                        </div>
                                        <div className="connection-card">
                                            <img src={pic3} alt="pic3" />
                                            <p>Amal Zakariya</p>
                                            <button className="connect-btn">Connect</button>
                                        </div>
                                        <div className="connection-card">
                                            <img src={pic4} alt="pic4" />
                                            <p>Khalid Ayman</p>
                                            <button className="connect-btn">Connect</button>
                                        </div>
                                        <div className="connection-card">
                                            <img src={pic5} alt="pic5" />
                                            <p>Muhamed Rayan</p>
                                            <button className="connect-btn">Connect</button>
                                        </div>
                                        <div className="connection-card">
                                            <img src={pic6} alt="pic6" />
                                            <p>Amal Nour Bin</p>
                                            <button className="connect-btn">Connect</button>
                                        </div>
                
                                    </div> */}
                </aside>
            </div>
            {downloadPopupOpen && (
                <>
                    <div className="overlay" onClick={() => setDownloadPopupOpen(false)}></div>
                    <div className="download-popup-drawer">
                        <div className="pop-up-img">
                            <img src={popup_yatch} alt="pop up yatch" className="pop-up-yatch" />
                        </div>
                        <div className="popup-header">
                            <div className="pop-up-download">
                                <div className="hayaticon">
                                    <img src={hayatlogo} alt="Hayat In Logo" />
                                    <div className="close-btn">
                                        <img src={xmark} alt="xmark" className="close-popup" onClick={() => setDownloadPopupOpen(false)} />
                                    </div>
                                </div>
                                <h4 className="download-hayat">Download Our App </h4>
                                <p id="App-description">
                                    Scan the QR code with your phone and open Hayat In instantly
                                    Your gateway to discovering the city in one tap.                                    </p>

                                <div className="store-buttons">
                                    <div className="app_qr">
                                        <a
                                            href="https://apps.apple.com/ae/app/hayat-in/id6738689937"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <img src={app_store} alt="App Store" />
                                        </a>

                                        <a
                                            href="https://play.google.com/store/apps/details?id=com.hayatinapp.hayatin"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <img src={play_store} alt="Google Play" />
                                        </a>
                                    </div>


                                    <div className="app_qr">
                                        <img className="qr" src={qr} alt="QR code" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default SearchPage;
